import NucleusComponentBase from "@/shared/application/nucleus-component-base";
import { Component, Watch } from "vue-property-decorator";
import Guid from "@/shared/helpers/guid-helper";
import { stringify } from "query-string";
var builder = require("utm-builder");
import Swal from "sweetalert2";

@Component
export default class CollectionListComponent extends NucleusComponentBase {
  refs = this.$refs as any;
  allPermissions: IPermissionDto[] = [];
  errors: INameValueDto[] = [];
  loading = true;
  dialog = false;
  formTitle = "";
  options = {};
  search = "";
  selectAll = false;


  username="";
  linkSource = {
    link: "",
    campaign: "",
    source: "",
    medium: "",
  };

  get headers() {
    return [
      { text: this.$t("Koleksiyon Adı"), value: "name" },
      { text: this.$t("Actions"), value: "action", sortable: false },
    ];
  }
  get headersCollectionItem() {
    return [
      { text: this.$t(""), value: "order" },
      { text: this.$t("Link "), value: "url" },
      { text: this.$t("Actions"), value: "action", sortable: false },
    ];
  }

  createOrUpdateCollectionInput = {
    collectionItems: [],
    collection: {} as ICollectionDto,
  } as ICreateOrUpdateCollectionInput;

  pagedListOfCollectionListDto: IPagedList<ICollectionListOutput> = {
    totalCount: 0,
    items: [],
  };

  collectionItemUrl="";

  public beforeMount() {
    this.getUserName();


  }

  @Watch("options")
  onPaginationChanged() {
    this.getCollections();
  }

  @Watch("search")
  onSearchChanged() {
    this.getCollections();
  }

  mounted() {
    this.getCollections();
  }

  editCollection(id: string) {
    this.formTitle = id
      ? this.$t("EditCollection").toString()
      : this.$t("NewCollection").toString();
    this.errors = [];
    this.nucleusService
      .get<IGetCollectionForCreateOrUpdateOutput>(
        "/api/collections/" + (id ? id : Guid.empty)
      )
      .then((response) => {
        const result = response.content as IGetCollectionForCreateOrUpdateOutput;
        this.createOrUpdateCollectionInput = {
          collection: result.collection,
          collectionItems: result.collectionItems
        };
        this.dialog = true;
      });
  }

  deleteCollection(id: string) {
    this.swalConfirm(this.$t("AreYouSureToDelete").toString()).then(
      (result) => {
        if (result.value) {
          this.nucleusService
            .delete("/api/collections?id=" + id)
            .then((response) => {
              if (!response.isError) {
                this.swalToast(
                  2000,
                  "success",
                  this.$t("Successful").toString()
                );
                this.getCollections();
              } else {
                var errorText = "";
                response.errors.forEach((error) => {
                  errorText += this.$t(error.name) + "<br>";
                });

                this.swalAlert("error", errorText);
              }
            });
        }
      }
    );
  }

  save() {

    if (this.refs.form.validate()) {
      this.errors = [];
      this.nucleusService
        .postOrPut<void>(
          "/api/collections",
          this.createOrUpdateCollectionInput as ICreateOrUpdateCollectionInput,
          this.createOrUpdateCollectionInput.collection.id
        )
        .then((response) => {
          if (!response.isError) {
            this.swalToast(2000, "success", this.$t("Successful").toString());
            this.dialog = false;
            this.getCollections();
          } else {
            this.errors = response.errors;
          }
        });
    }
  }

  getCollections() {
    this.loading = true;
    const { sortBy, sortDesc, page, itemsPerPage }: any = this.options;
    const collectionListInput: IPagedListInput | any = {
      filter: this.search,
      pageIndex: page - 1,
      pageSize: itemsPerPage,
    };

    if (sortBy.length > 0 && sortBy[0]) {
      collectionListInput.sortBy =
        sortBy + (sortDesc.length > 0 && sortDesc[0] ? " desc" : "");
    }

    const query = "?" + this.queryString.stringify(collectionListInput);
    this.nucleusService
      .get<IPagedList<ICollectionListOutput>>("/api/collections" + query, false)
      .then((response) => {
        this.pagedListOfCollectionListDto = response.content as IPagedList<
          ICollectionListOutput
        >;
        this.loading = false;
      });
  }
  addCollectionItem(){
    this.createLink(this.collectionItemUrl);

   
    this.collectionItemUrl="";
  }
  deleteCollectionItem(item:any){
    this.createOrUpdateCollectionInput.collectionItems.splice(this.createOrUpdateCollectionInput.collectionItems.indexOf(item),1);
  }


  getUserName() {
    var id = this.authStore.getTokenData()[
      "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
    ];
    console.log(id);
    this.nucleusService
      .get<IGetUserForCreateOrUpdateOutput>(
        "/api/profile/GetUserNameWithId?id=" + id
      )
      .then((response) => {
        const result = response.content as IGetUserForCreateOrUpdateOutput;
        this.username = result.user.userName;

        this.linkSource.source = "influencer_" + this.username.toLowerCase();
      });
  }

  createLink(link : any) {
    var message = "";
    

    var utmLink = builder(
     link,
      "influencer_" + this.username.toLowerCase(),
      'affiliate', 
       'tatil'
    );
    console.log(utmLink);
    var encodedLink = encodeURIComponent(utmLink);

   
        this.createOrUpdateCollectionInput.collectionItems.push({url:utmLink,order:this.createOrUpdateCollectionInput.collectionItems.length+1});
       
       
     
  }
}
